export const initialState = {
	lokasi: {
		body: [],
		count: 1,
		sisa: true,
		limit: 10,
		pages: 1,
	},
	organisasi: {
		body: [],
		count: 1,
		sisa: true,
		limit: 10,
		pages: 1,
	},
	loadingLokasi: false,
	loadingOrganisasi: false,
};

export const actions = {
	CHANGE_ORGANISASI: "CHANGE_ORGANISASI",
	CHANGE_LOADING_ORGANISASI: "CHANGE_LOADING_ORGANISASI",

	CHANGE_LOKASI: "CHANGE_LOKASI",
	CHANGE_LOADING_LOKASI: "CHANGE_LOADING_LOKASI",
};
